import { gql, useMutation } from '@apollo/client';
import { AnyObject } from '../../models/types';

interface RequestOnDemandRTFMetricsVars {
  domainId: string;
  eventType: string;
  startTime: string;
  endTime: string;
  reBackfill: string;
  instanceIds: string[]; 
  metrics: string[];      
}

export const REQUEST_ON_DEMAND_RTF_METRICS = gql`
  mutation requestOnDemandRTFMetrics(
    $domainId: String
    $eventType: String
    $startTime: String
    $endTime: String
    $reBackfill: String
    $instanceIds: [String]
    $metrics: [String]
  ) {
    requestOnDemandRTFMetrics(
      domainId: $domainId
      eventType: $eventType
      startTime: $startTime
      endTime: $endTime
      reBackfill: $reBackfill
      instanceIds: $instanceIds
      metrics: $metrics
    ) 
  }
`;

export const useRequestOnDemandRTFMetricsMutation = () => {
  return useMutation<AnyObject, RequestOnDemandRTFMetricsVars>(REQUEST_ON_DEMAND_RTF_METRICS,
    {
      fetchPolicy: 'no-cache'
    });
};